import { supabase } from "@/integrations/supabase/client";

/**
 * Syncs a subscriber to MailerLite via backend function.
 * Fire-and-forget — errors are logged but don't block the user flow.
 */
export const syncToMailerLite = async (email: string, source: string) => {
  try {
    const { error } = await supabase.functions.invoke("sync-mailerlite", {
      body: { email, source },
    });
    if (error) {
      console.error("MailerLite sync error:", error);
    }
  } catch (err) {
    console.error("MailerLite sync failed:", err);
  }
};
